import LayoutActividad from "../../../components/LayoutActividad";
import Imagen1 from "../../../images/modulo2/rampa.png";
import Imagen2 from "../../../images/modulo2/calle.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faComments } from "@fortawesome/free-solid-svg-icons";
import { modulo2 } from "../../../routes/Module2";
import Sidebar from "../Sidebar";
import GuiaDocente from "../../../components/GuiaDocente";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo2/Actividad 5.mp3";

const Actividad5 = () => {
  const infoUnidad = modulo2.content[0];
  const infoAct = modulo2.content[0].activities[4];
  const crumbs = [
    {
      title: modulo2.title,
      url: "/" + modulo2.url,
    },
    {
      title:
        modulo2.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo2.content[0].activities[5].name}`,
    linkNext: `${modulo2.url}/${modulo2.content[0].path}/${modulo2.content[0].activities[5].path}`,
    titlePrev: `${modulo2.content[0].activities[3].name}`,
    linkPrev: `${modulo2.url}/${modulo2.content[0].path}/${modulo2.content[0].activities[3].path}`,
  };
  const metadata = {
    color: modulo2.color,
    title: `${modulo2.title} - ${infoAct.name}`,
    name: modulo2.title
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo2.color} hat-text`}>
          <FontAwesomeIcon icon={faComments} /> Dialogamos
        </small>
      </p>

      <h2 className="mb-5">Actividad 5</h2>
      <AudioPlayer track={Audio} />

      <ul>
        <li>
          A veces en nuestras ciudades y barrios hay problemas que afectan
          nuestra vida en comunidad.
        </li>
        <li>Observa las siguientes imágenes.</li>
      </ul>
      <div className="row mt-5 align-items-center">
        <div className="col-md-6 col-xs-12">
          <img src={Imagen1} alt="Familia" className="img-fluid" />
        </div>
        <div className="col-md-6 col-xs-12">
          <img src={Imagen2} alt="Familia" className="img-fluid" />
        </div>
      </div>

      <ul className="mt-5">
        <li>
          Conversa con un compañero, compañera o familiar sobre estas preguntas.
        </li>
      </ul>
      <div>¿Qué ocurre en cada una de las imágenes?</div>
      <textarea className="form-control mt-1 mb-3" rows={3} />
      <div>¿Qué problemas causan?</div>
      <textarea className="form-control mt-1 mb-3" rows={3} />
      <div>¿Alguno de estos problemas se presenta en tu barrio?</div>
      <textarea className="form-control mt-1 mb-3" rows={3} />

      <GuiaDocente>
        <p>
          Lea las indicaciones y observen las imágenes. Explique que cada una de
          ellas presenta un problema. Dialoguen acerca de las respuestas a las
          preguntas.
        </p>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad5;
